import { render, staticRenderFns } from "./Saving.vue?vue&type=template&id=10bdd86a&scoped=true"
import script from "./Saving.vue?vue&type=script&lang=js"
export * from "./Saving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bdd86a",
  null
  
)

export default component.exports